import axios from "axios";

const BASE_URL = process.env.REACT_APP_NODEJS_SERVER_URL;

const auth = () => ({
  headers: {
    accessToken: localStorage.getItem("accessToken"),
  },
});

export const fetchOperationsManagementRelationships = async (instanceUniqueId) => {
  const response = await axios.get(`${BASE_URL}/operations-management/relationships`, {
    ...auth(),
    params: { instanceUniqueId },
  });
  return response.data;
};

export const fetchOperationsManagementTeams = async (instanceUniqueId) => {
  const response = await axios.get(`${BASE_URL}/operations-management/teams`, {
    ...auth(),
    params: { instanceUniqueId },
  });
  return response.data;
};

export const fetchOperationsManagementSettings = async (instanceUniqueId) => {
  const response = await axios.get(`${BASE_URL}/operations-management/settings`, {
    ...auth(),
    params: { instanceUniqueId },
  });
  return response.data;
};

export const saveOperationsManagementSettings = async (payload) => {
  const response = await axios.put(
    `${BASE_URL}/operations-management/settings`,
    payload,
    auth()
  );
  return response.data;
};

export const testWebsiteLeadEmail = async (instanceUniqueId) => {
  const response = await axios.post(
    `${BASE_URL}/operations-management/settings/test-website-lead-email`,
    { instanceUniqueId },
    auth()
  );
  return response.data;
};

export const fetchInstanceDefaultsByUniqueId = async (instanceUniqueId) => {
  const instanceResponse = await axios.get(`${BASE_URL}/instances/byinstanceUniqueId/${instanceUniqueId}`, auth());
  const instanceId = instanceResponse.data?.id;
  if (!instanceId) return { instanceId: null, defaults: {} };

  const defaultsResponse = await axios.get(`${BASE_URL}/instances/${instanceId}/defaults`, auth());
  return {
    instanceId,
    defaults: defaultsResponse.data?.defaults || {},
  };
};

export const saveInstanceDefaults = async (instanceId, payload) => {
  const response = await axios.put(
    `${BASE_URL}/instances/${instanceId}/defaults`,
    payload,
    auth()
  );
  return response.data;
};

export const createOperationsManagementRelationship = async (payload) => {
  const response = await axios.post(`${BASE_URL}/operations-management/relationships`, payload, auth());
  return response.data;
};

export const updateOperationsManagementRelationship = async (relationshipId, payload) => {
  const response = await axios.put(
    `${BASE_URL}/operations-management/relationships/${relationshipId}`,
    payload,
    auth()
  );
  return response.data;
};

export const updateOperationsManagementRelationshipStatus = async (
  relationshipId,
  payload
) => {
  const response = await axios.post(
    `${BASE_URL}/operations-management/relationships/${relationshipId}/status`,
    payload,
    auth()
  );
  return response.data;
};

export const fetchOperationsManagementTermRequests = async (
  instanceUniqueId,
  params = {}
) => {
  const response = await axios.get(`${BASE_URL}/operations-management/term-requests`, {
    ...auth(),
    params: {
      instanceUniqueId,
      ...params,
    },
  });
  return response.data;
};

export const reviewOperationsManagementTermRequest = async (requestId, payload) => {
  const response = await axios.post(
    `${BASE_URL}/operations-management/term-requests/${requestId}/review`,
    payload,
    auth()
  );
  return response.data;
};
